var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-wrapper"},[_c('hero',{attrs:{"pageTitle":"Add A Quote","pageDescription":"Share the moment you find inspiration","showCTA":false}}),_c('add-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }